import { Component, EventEmitter, Injectable, OnInit, Output } from "@angular/core";
import { FormBuilder } from "@angular/forms"
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router"
import { AuthService } from "../../../_common/_service/authservice.service";
import { TokenStorageService } from "../../../_common/_service/token-storage.service";

import { ToastrService } from 'ngx-toastr';
import { CommonService } from "../../../_common/_service/user.service";

import { InvoiceDetailComponent } from "../../popup/InvoiceDetail/InvoiceDetail.component";
import { MatDatepickerInputEvent } from "@angular/material/datepicker";
import { DatePipe, formatDate } from '@angular/common';
import { DateAdapter, MAT_DATE_FORMATS, NativeDateAdapter } from '@angular/material/core';
import { Clipboard } from '@angular/cdk/clipboard';



export const PICK_FORMATS = {
  parse: { dateInput: { month: 'short', year: 'numeric', day: 'numeric' } },
  display: {
    dateInput: 'input',
    monthYearLabel: { year: 'numeric', month: 'short' },
    dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
    monthYearA11yLabel: { year: 'numeric', month: 'long' }
  }
};

@Injectable()
class PickDateAdapter extends NativeDateAdapter {
  format(date: Date, displayFormat: Object): string {
    if (displayFormat === 'input') {
      debugger
      return formatDate(date, 'dd-MMM-yyyy', this.locale);
    } else {
      return date.toDateString();
    }
  }
}

@Component({
  selector: 'app-PromoList',
  templateUrl: './PromoList.component.html',
  styleUrls: ['./PromoList.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: PickDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: PICK_FORMATS }
  ]
})

export class PromoListComponent implements OnInit {

  TransactionType: any;
  DownloadType: any;
  DateTo: any;
  DateFrom: any;
  Code: any;
  token: any;
  PromoListdetailList: any;
  submitted = false;
  pageNumber = 1;
  total_count = 0;
  UsertBal: any;

  pageSize = 10;
  exitvalue: any;
  currentDate = new Date();
  currentUser: any;
  pageSizeOptions = [10, 25, 50, 100];
  @Output() filterSelection = new EventEmitter<any>();
  loadingspinner: boolean = false;

  constructor(
    public dialog: MatDialog,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private authService: AuthService, private tokenStorageService: TokenStorageService, private router: Router, private _service: CommonService,
    public clipboard: Clipboard

  ) { }


  ngOnInit() {

    // this.exitvalue = new Date("03/01/2022");
    this.token = this.tokenStorageService.getToken();

    if (this.token) {

      this.currentUser = this.tokenStorageService.getUser();

      this.PromoListTransactions();
    }
    else {
      this._service.callMethodOfSecondComponent();
    }
  }


  Back() {

    this.router.navigate(['/Go-on']);
  }


  /**handle*/
  handle(event: any) {
    this.pageSize = event.pageSize;
    this.pageNumber = event.pageIndex + 1;
    this.PromoListTransactions();
  }


  PromoListTransactions() {
    var body = {
      Email: this.currentUser.email,
      recordperpage: this.pageSize,
      page: this.pageNumber
    }
    this.loadingspinner = true;
    this.authService.getPromoList(body).subscribe(response => {
      debugger

      this.loadingspinner = false;
      if (response.apiStatus == true && response.apiData.totalCount != 0) {
        this.PromoListdetailList = response.apiData.data;
        this.total_count = response.apiData.totalCount;

      }
      else if (response.apiStatus == true && response.apiData.totalCount == 0) {
        this.PromoListdetailList = response.apiData.data;

        //this.total_count = response.headers.get('totalCount');

      }
      else {

        this.toastr.error(response.apiMessage, "Error");
      }

    }, (err: any) => {
      this.loadingspinner = false;
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {
        this.toastr.error(err.error, 'Error');
      }
    }
    );

  }

  
  copyToClipboard(text: any) {
    debugger
    this.clipboard.copy(text);
    this.toastr.success('VoucherCode Copy');
  }
 

  
  filterObj = {
    DateFrom: null,
    DateTo: null,
  };

  /**changeFromDate */
  changeFromDate(event: MatDatepickerInputEvent<Date>) {
    if (this.DateTo < this.DateFrom) {
      this.DateTo = '';
    }
    ;
    this.DateFrom = event.value;
  }

  /**changeToDate */
  changeToDate(event: MatDatepickerInputEvent<Date>) {
    this.DateTo = event.value;
    this.filterObj.DateFrom = this.getDateFromMoment(this.DateFrom);
    this.filterObj.DateTo = this.getDateFromMoment(this.DateTo);

    this.filterSelection.emit(this.filterObj);
  }

  /**changeStatus */
  changeStatus(event: any) {
    this.filterSelection.emit(this.filterObj);
  }

  getDateFromMoment(date: any) {
    if (date) {
      var d = date;
      return new DatePipe('en-us').transform(d, 'MM/dd/yyyy');;
    }
    return date;
  }

  downloadReport() {
    if (!this.DateFrom && !this.DateTo) {
      return alert('select both date');
    }
    this.DateFrom = formatDate(this.DateFrom, 'yyyy-MM-dd', 'en-US');
    this.DateTo = formatDate(this.DateTo, 'yyyy-MM-dd', 'en-US');

    const params = {
      DateFrom: this.DateFrom,
      DateTo: this.DateTo
      //DownloadType: 1,
      //TransactionType: 4,
      //Code: this.currentUser.WalletUserId
    }
    debugger;
    this.loadingspinner = true;
    this.authService.downloadTransactionLogs(params).subscribe(response => {
      debugger;
      this.loadingspinner = false;
      let b: any = new Blob([response], { type: 'text/csv' });
      var url = window.URL.createObjectURL(b);
      // window.open(url, '_blank');

      var a = document.createElement("a");
      document.body.appendChild(a);

      a.href = url;
      a.download = "TransactionStatementLogs_" + new Date().getTime() + (".csv");
      a.click();
      window.URL.revokeObjectURL(url);

    }, (err: any) => {
      this.loadingspinner = false;
      if (err.error instanceof Error) {
        //this.toastr.error(AppConstant.errorOccured, AppConstant.error, { toastTimeout: 4000, maxShown: 1 });
      } else {
        //this.toastr.errorToastr(AppConstant.errorOccured, AppConstant.error, { toastTimeout: 4000, maxShown: 1 });
      }
    }
    );
  }

  downloadReportpdf() {
    if (!this.DateFrom && !this.DateTo) {
      return alert('select both date');
    }

    const params = {

      DateFrom: this.filterObj.DateFrom ? this.filterObj.DateFrom : null,
      DateTo: this.filterObj.DateTo ? this.filterObj.DateTo : null

    }
    this.loadingspinner = true;
    this.authService.reportpdf(params).subscribe(response => {
      debugger;
      this.loadingspinner = false;
      let b: any = new Blob([response], { type: 'attachment; filename=TransactionStatement.pdf' });
      var url = window.URL.createObjectURL(b);
      // window.open(url, '_blank');

      var a = document.createElement("a");
      document.body.appendChild(a);
      // a.style = "display: none";

      a.href = url;
      a.download = "Logs_" + new Date().getTime() + (".pdf");
      a.click();
      window.URL.revokeObjectURL(url);

    }, (err: any) => {
      this.loadingspinner = false;
      if (err.error instanceof Error) {
        //this.toastr.error(AppConstant.errorOccured, AppConstant.error, { toastTimeout: 4000, maxShown: 1 });
      } else {
        //this.toastr.errorToastr(AppConstant.errorOccured, AppConstant.error, { toastTimeout: 4000, maxShown: 1 });
      }
    }
    );
  }

}
